import * as React from "react";
import { Path, G, ClipPath, Defs, Rect, Mask } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const IMIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="IM" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#E31D1C"
        fillRule="evenodd"
        d="M0 0v12h16V0H0Z"
        clipRule="evenodd"
      />
      <Mask
        id="b"
        width={16}
        height={12}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <Path
          fill="#fff"
          fillRule="evenodd"
          d="M0 0v12h16V0H0Z"
          clipRule="evenodd"
        />
      </Mask>
      <G mask="url(#b)">
        <Path
          fill="#F7FCFF"
          fillRule="evenodd"
          d="M3.047 2.07c-.004-.046.051-.068.083-.034.224.246.818.858 1.16.858.43 0 2.117-1.421 2.616-1.19.498.232 1.508 2.653 1.508 2.653l-.658.825-.85-.464-.16-1.824s-1.637.842-2.455.536l-.46.386s-.442-.876-.617-1.144c-.115-.178-.154-.442-.167-.601Z"
          clipRule="evenodd"
        />
        <Path
          fill="#FECA00"
          fillRule="evenodd"
          d="m4.131 4.062-.28.17.054-.36-.227-.254.313-.052.14-.327.14.327.313.052-.227.255.054.359-.28-.17ZM6.506 1.896a.181.181 0 1 1 .363 0v.857a.181.181 0 0 1-.363 0v-.857Z"
          clipRule="evenodd"
        />
        <Path
          fill="#F7FCFF"
          fillRule="evenodd"
          d="M12.61 2.552c.041.021.031.08-.015.088-.327.06-1.16.24-1.343.53-.227.365.084 2.549-.376 2.849-.46.3-3.049-.127-3.049-.127l-.35-.995.843-.475 1.632.83s.153-1.834.846-2.365l-.084-.595s.978.09 1.297.083c.212-.003.457.104.6.177Z"
          clipRule="evenodd"
        />
        <Path
          fill="#FECA00"
          fillRule="evenodd"
          d="m10.347 2.416.004-.327.276.235.336-.057-.121.293.203.292-.352-.054-.21.237-.096-.327-.333-.145.293-.147ZM10.957 5.603a.196.196 0 1 1-.212.33l-.774-.518a.18.18 0 0 1 .195-.303l.791.49Z"
          clipRule="evenodd"
        />
        <Path
          fill="#F7FCFF"
          fillRule="evenodd"
          d="M7.431 10.492c-.039.025-.085-.013-.069-.057.112-.314.373-1.125.212-1.428-.201-.38-2.248-1.201-2.278-1.75-.03-.55 1.634-2.577 1.634-2.577l1.037.193-.01.969-1.535.998s1.511 1.05 1.626 1.915l.556.225s-.566.802-.72 1.082c-.103.185-.319.344-.453.43Z"
          clipRule="evenodd"
        />
        <Path
          fill="#FECA00"
          fillRule="evenodd"
          d="m8.68 8.6.282.167-.342.122-.119.319-.193-.252-.354.03.223-.277-.1-.3.33.08.292-.216-.018.327ZM5.552 7.479a.203.203 0 0 1-.147-.38l.834-.325a.207.207 0 1 1 .15.386l-.837.319Z"
          clipRule="evenodd"
        />
        <Path
          fill="#FECA00"
          d="M6.831 4.883a.123.123 0 0 1-.074-.155c.021-.064.121-.17.183-.149l.868.304a.121.121 0 0 1 .08.105l.078.952c.005.067-.092.121-.158.127a.12.12 0 0 1-.128-.112l-.072-.818-.777-.254Z"
        />
        <Path
          fill="#FECA00"
          d="M8.34 4.384c.052-.042.145.006.185.06.04.053.031.13-.02.17l-.602.617c-.052.041-.168-.04-.209-.093-.04-.053-.052-.197 0-.239l.646-.515Z"
        />
      </G>
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
